// Images still downloading. Holding a reference keeps a browser from
// garbage-collecting the off-screen <img> — which can cancel its request —
// before the file is in the HTTP cache.
const pendingPreloads = new Set();

/**
 * Starts downloading images in the background so a screen that shows them
 * later paints them from the HTTP cache instead of popping them in.
 *
 * Fire-and-forget: nothing waits on it, and a failed download is simply
 * dropped (the screen that needs the image requests it again as normal).
 *
 * @param {string[]} urls - image URLs; empty or non-string entries are skipped.
 * @returns {void}
 */
export const preloadImages = (urls = []) => {
  urls.forEach((url) => {
    if (typeof url !== 'string' || !url) return;
    const img = new Image();
    img.decoding = 'async';
    const release = () => pendingPreloads.delete(img);
    img.onload = release;
    img.onerror = release;
    pendingPreloads.add(img);
    img.src = url;
  });
};
